/**
 * Action type constants for RAPBox Management feature.
 */

// Fetch all RAPBoxes
export const RAPBOX_FETCH_REQUEST = "RAPBOX_FETCH_REQUEST";
export const RAPBOX_FETCH_SUCCESS = "RAPBOX_FETCH_SUCCESS";
export const RAPBOX_FETCH_ERROR   = "RAPBOX_FETCH_ERROR";

// Fetch configuration for a single RAPBox
export const RAPBOX_CONFIG_FETCH_REQUEST = "RAPBOX_CONFIG_FETCH_REQUEST";
export const RAPBOX_CONFIG_FETCH_SUCCESS = "RAPBOX_CONFIG_FETCH_SUCCESS";
export const RAPBOX_CONFIG_FETCH_ERROR   = "RAPBOX_CONFIG_FETCH_ERROR";

// Save / update a RAPBox configuration
export const RAPBOX_CONFIG_SAVE_REQUEST = "RAPBOX_CONFIG_SAVE_REQUEST";
export const RAPBOX_CONFIG_SAVE_SUCCESS = "RAPBOX_CONFIG_SAVE_SUCCESS";
export const RAPBOX_CONFIG_SAVE_ERROR   = "RAPBOX_CONFIG_SAVE_ERROR";

// Fetch health diagnostics for all RAPBoxes
export const RAPBOX_HEALTH_FETCH_REQUEST = "RAPBOX_HEALTH_FETCH_REQUEST";
export const RAPBOX_HEALTH_FETCH_SUCCESS = "RAPBOX_HEALTH_FETCH_SUCCESS";
export const RAPBOX_HEALTH_FETCH_ERROR   = "RAPBOX_HEALTH_FETCH_ERROR";

// UI-only actions
export const RAPBOX_SELECT_DEVICE     = "RAPBOX_SELECT_DEVICE";
export const RAPBOX_CLOSE_MSG_POPUP   = "RAPBOX_CLOSE_MSG_POPUP";
export const RAPBOX_RESET_STATE       = "RAPBOX_RESET_STATE";
/** Clears the accumulated device list and hasMore flag — dispatched before a fresh
 *  fetch (initial load, search change) so the InfiniteScroll resets cleanly. */
export const RAPBOX_RESET_LIST        = "RAPBOX_RESET_LIST";

// Fetch transferred files for the File Retrieval section
export const RAPBOX_TRANSFERRED_FILES_FETCH_REQUEST = "RAPBOX_TRANSFERRED_FILES_FETCH_REQUEST";
export const RAPBOX_TRANSFERRED_FILES_FETCH_SUCCESS = "RAPBOX_TRANSFERRED_FILES_FETCH_SUCCESS";
export const RAPBOX_TRANSFERRED_FILES_FETCH_ERROR   = "RAPBOX_TRANSFERRED_FILES_FETCH_ERROR";

// Request a new RA file retrieval (Retrieve File button)
export const RAPBOX_FILE_RETRIEVE_REQUEST = "RAPBOX_FILE_RETRIEVE_REQUEST";
export const RAPBOX_FILE_RETRIEVE_SUCCESS = "RAPBOX_FILE_RETRIEVE_SUCCESS";
export const RAPBOX_FILE_RETRIEVE_ERROR   = "RAPBOX_FILE_RETRIEVE_ERROR";
export const RAPBOX_FILE_RETRIEVE_RESET   = "RAPBOX_FILE_RETRIEVE_RESET";

// Update an in-flight transferred-file's status from a Service Bus message
export const RAPBOX_TRANSFERRED_FILE_STATUS_UPDATE = "RAPBOX_TRANSFERRED_FILE_STATUS_UPDATE";

// Default empty filter state for the Device Overview search form
export const EMPTY_FILTERS = { raId: "", serialNumber: "", instanceNumber: "", customer: "", site: "" };

// Fallback display value for empty/null table cells
export const EMPTY_CELL = "-";

// Placeholder labels for the Device Overview filter inputs
export const PLACEHOLDER_RA_ID           = "Enter RA ID";
export const PLACEHOLDER_SERIAL_NUMBER   = "Enter Serial Number";
export const PLACEHOLDER_INSTANCE_NUMBER = "Enter Instance Number";
export const PLACEHOLDER_CUSTOMER        = "Enter Customer";
export const PLACEHOLDER_SITE            = "Enter Site";

// Download a transferred file (generate datalake URL)
export const RAPBOX_FILE_DOWNLOAD_REQUEST = "RAPBOX_FILE_DOWNLOAD_REQUEST";
export const RAPBOX_FILE_DOWNLOAD_SUCCESS = "RAPBOX_FILE_DOWNLOAD_SUCCESS";
export const RAPBOX_FILE_DOWNLOAD_ERROR   = "RAPBOX_FILE_DOWNLOAD_ERROR";
export const RAPBOX_FILE_DOWNLOAD_RESET   = "RAPBOX_FILE_DOWNLOAD_RESET";

// Launch RAPBox RDS (Remote Access)
export const RAPBOX_LAUNCH_RDS_REQUEST = "RAPBOX_LAUNCH_RDS_REQUEST";
export const RAPBOX_LAUNCH_RDS_SUCCESS = "RAPBOX_LAUNCH_RDS_SUCCESS";
export const RAPBOX_LAUNCH_RDS_ERROR   = "RAPBOX_LAUNCH_RDS_ERROR";
export const RAPBOX_LAUNCH_RDS_RESET            = "RAPBOX_LAUNCH_RDS_RESET";
export const RAPBOX_LAUNCH_RDS_SESSION_COMPLETE = "RAPBOX_LAUNCH_RDS_SESSION_COMPLETE";
export const RAPBOX_LAUNCH_RDS_SESSION_ERROR    = "RAPBOX_LAUNCH_RDS_SESSION_ERROR";

export const GENERIC_ERROR_MESSAGE =
  "Failed - Due to a technical error. Please try again.";

// File Retrieval Section
export const FILE_PAGE_SIZE = 20;
export const BACKSLASH_REGEX = /\\/g;
export const WILDCARD_FILENAME_REGEX = /^\*\.\*/;

// Transferred file status values returned by the backend
export const FILE_STATUS_SUCCESS = "SUCCESS";
export const FILE_STATUS_FAILURE = "FAILURE";
export const FILE_STATUS_FAILED  = "FAILED";
export const FILE_STATUS_DELETED = "DELETED";
export const FILE_STATUS_PENDING = "PENDING";
export const MSG_NO_FILES_RETRIEVED = "No files retrieved yet. Enter RA ID and file path, then click Retrieve File.";

// ─── Section identifiers ──────────────────────────────────────────────────────
export const SECTION_OVERVIEW       = "overview";
export const SECTION_FILE_RETRIEVAL = "file_retrieval";
export const SECTION_SSH_TERMINAL   = "ssh_terminal";
export const SECTION_REMOTE_EXECUTION = "remote_execution";

// ─── Modal titles and messages ───────────────────────────────────────────────
export const MODAL_RETRIEVE_TITLE           = "FILE RETRIEVAL REQUESTED";
export const MODAL_RETRIEVE_MSG             = "File Retrieval Request Initiated Successfully";
export const MODAL_RETRIEVE_ERR_HEADING     = "File Retrieval Failed";
export const MODAL_RETRIEVE_ERR_MSG         = "The file retrieval request could not be submitted. Please try again or contact Admin.";
export const MODAL_DOWNLOAD_TITLE           = "ACCESS RA FILES";
export const MODAL_DOWNLOAD_MSG             = "Selected file will be exported to the folder configured in the browser.";
export const MODAL_DOWNLOAD_ERR_HEADING     = "File Download Failed";
export const MODAL_DOWNLOAD_ERR_MSG         = "Downloading the file has encountered an error. Please try again or contact Admin.";

// ─── SSH Terminal modal display states ─────────────────────────────────────────
export const MODAL_IDLE    = "idle";
export const MODAL_LOADING = "loading";
export const MODAL_SUCCESS = "success";
export const MODAL_ERROR   = "error";

// ─── SSH Terminal modal strings ────────────────────────────────────────────────────
export const MODAL_RDS_TITLE           = "RAPBOX REMOTE ACCESS";
export const MODAL_RDS_SUCCESS_MSG     = "Remote access session launched. Select the downloaded file to begin.";
export const MODAL_RDS_ERR_DOWNLOAD    = "Download failed. Please try again.";
export const MODAL_RDS_ERR_LAUNCH      = "Failed to launch RDS session. Please try again.";
